import { useResetAtom } from 'jotai/utils'
import { useUnmount } from 'react-use'

import { dialogInfoAtom, searchWordAtom, showAllAtom } from '../atoms'

export const useResetOnUnmount = () => {
  const resetSearchWord = useResetAtom(searchWordAtom)
  const resetShowAll = useResetAtom(showAllAtom)
  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  useUnmount(() => {
    resetSearchWord()
    resetShowAll()
    resetDialogInfo()
  })
}
